import React, { Component } from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { HashLink as Link } from 'react-router-hash-link';
import { Spring } from 'react-spring';
import SweetAlert from 'sweetalert-react';
import SearchInput from 'components/SearchModal/SearchInput';

import {
  APIHandler,
  StorageHandler,
  BackVideo,
  DataHandler,
  StoreButtons,
  NotificationSlider,
} from 'C4';
import { baseAppId, storageKeys, bgVideo } from 'settings';

import Logo from 'assets/images/logo/logo_alpha_dark.png';

export default class HomeView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      query: '',
      unreadMessageCount: 0,
      lastCheckedMessages: '1993-01-10',
      appId: -1,
      userStatus: 'startTraining',
      noAgent: false,
      trainingComplete: false,
      offers: false,
    };
  }

  componentWillMount() {
    document.body.classList.add('no-scroll');
    StorageHandler.load(storageKeys.lastCheckedMessage).then((res) => {
      if (res) {
        this.setState({ lastCheckedMessages: res });
      }
      this.checkForUnreadMessages();
    });

    StorageHandler.load(storageKeys.user).then((res) => {
      if (res.training_graduated) {
        return this.setState({ userStatus: 'graduated' });
      }
      if (res.training_started) {
        return this.setState({ userStatus: 'continueTraining' });
      }
      return this.setState({ userStatus: 'startTraining' });
    });
  }

  componentDidMount() {
    const d = new Date(Date.now());
    const leading = (val) => `0${val}`.slice(-2);

    DataHandler.matchAppId().then((appId) => {
      this.setState({ appId });
      StorageHandler.load(storageKeys.user).then((user) => {
        if (user && user.sales_companion_registered === null) {
          const obj = user;
          const date = `${d.getFullYear()}-${leading(
            d.getMonth() + 1
          )}-${leading(d.getDate())}`;

          APIHandler.updateUser(appId, obj.email, [
            { param: 'sales_companion_registered', val: date },
          ]).then((res) => {
            if (res) {
              obj.sales_companion_registered = date;
              StorageHandler.save(storageKeys.user, obj);
            }
          });
        }
      });
    });

    this.getUserProgress();
  }

  componentWillUnmount() {
    document.body.classList.remove('no-scroll');
  }

  setQuery() {
    const { query } = this.state;
    if (query.length > 0) {
      StorageHandler.save(storageKeys.lastSearchQuery, query);
    }
  }

  getUserProgress() {
    StorageHandler.load(storageKeys.user).then((user) => {
      APIHandler.getUserProgress(baseAppId, user.email).then((res) => {
        if (res && res.data && res.data[0] && res.data[0].chapters) {
          const allChapters = res.data[0].chapters;
          const numOfChapters = allChapters.length;
          let totalProgress = 0;
          allChapters.forEach((chapter) => {
            const chapterProgress = Math.floor(
              (100 / chapter.total_pages) * chapter.progress
            );
            totalProgress += chapterProgress;
          });

          if (totalProgress >= numOfChapters * 100) {
            this.setState({
              trainingComplete: true,
            });
          }
        }
      });
    });
  }

  checkForUnreadMessages() {
    DataHandler.requestWithId(
      APIHandler.getUnreadMessages,
      this.state.lastCheckedMessages
    ).then((res) => {
      if (res && res.missed_items && res.missed_items[0]) {
        this.setState({ unreadMessageCount: res.missed_items[0].count });
      }
    });
  }

  closePopup() {
    this.setState({ offers: false });
  }

  render() {
    const { unreadMessageCount, appId, offers, noAgent, trainingComplete } =
      this.state;

    const close = () => {
      this.setState({
        noAgent: false,
      });
    };

    return (
      <div className="homeContainer">
        {bgVideo && <BackVideo />}
        <div className="bgHome" />

        <img src={`/${Logo}`} className="homeLogo" alt="logo" />
        <Spring
          from={{ transform: 'translateY(30%)', opacity: 0 }}
          to={{ transform: 'translateY(0%)', opacity: 1 }}
        >
          {(props) => (
            <div className="homeView" style={props}>
              <div className="homeView__title">
                <h1>Destinations for every dream</h1>
                <div className="homeView__title--line" />
                <div className="homeView__title--action">
                  <SearchInput />
                  {/* <div className="homepage__buttons">
                    <a
                      href="https://front.travpromobile.com/842/FAT_Incentive.pdf"
                      data-fancybox="rewards"
                      className="startTrain"
                    >
                      <p>
                        <FontAwesomeIcon icon={["fas", "treasure-chest"]} />
                        <span>{i18n.translate("nav.rewards")}</span>
                      </p>
                    </a>
                  </div> */}
                </div>
              </div>
              <SweetAlert
                title=""
                show={offers}
                html
                text="Unlock this item by completing the Learn section.<br/><br/>"
                customClass="noAgent"
                showConfirmButton={false}
                cancelButtonText={i18n.translate('general.close')}
                showCancelButton
                onConfirm={() => {
                  this.closePopup();
                }}
                onCancel={() => {
                  this.closePopup();
                }}
                onEscapeKey={() => {
                  this.closePopup();
                }}
                onOutsideClick={() => {
                  this.closePopup();
                }}
              />
            </div>
          )}
        </Spring>
        <div className="top-bar" />
        <div className="bottom-gradient" />
        <div className="bottom-bar" />

        <NotificationSlider appId={appId} middle right />
        {/* <SweetAlert
          title="This feature is Coming Soon"
          show={noAgent}
          imageUrl={Logo2}
          imageWidth="50rem"
          imageHeight="50rem"
          html
          text=""
          customClass="noAgent"
          showConfirmButton={false}
          cancelButtonText={i18n.translate('general.close')}
          showCancelButton
          onConfirm={close}
          onCancel={close}
          onEscapeKey={close}
          onOutsideClick={close}
        /> */}
      </div>
    );
  }
}
